// Namespace for Comet functionality
if(typeof C === 'undefined') {
	C = {};
}

C.clamp = function() {
	$('.clamp').each(function(i, e) {
		e = $(e);
		$clamp(e.children()[0], {clamp: e.data('clamp')});
	});
};

C.browser = {
	// Detect if date input is supported
	dateInput: function() {
		var elem = document.createElement('input');
		elem.setAttribute('type','date');
		elem.value = 'foo';
		return (elem.type == 'date' && elem.value != 'foo');
	}
};

C.initDatePickers = function() {
	if (!C.browser.dateInput()) {
  	$('input.date-picker').datetimepicker({
			timepicker: false,
			format: 'm/d/Y'
		});
	}
};

// parseFloat that works with strings containing commas
parseMoney = function(amount) {
	if (typeof amount == 'string') {
		return parseFloat(amount.replace(/,/g, ''));
	} else {
		return parseFloat(amount);
	}
};

$('form').attr('novalidate', 'novalidate');

// Format a number, adding commas as the thousands seperator
// and adding/removing insignificant digits to the right of the decimal place.
//
// n - a Number or String to format
// decimalPlaces - max number of insignificant decimal places to show 
//                 if decimal places is null or undefined, 0's will be
//                 trimmed from the end of the decimal places
//
// Examples:
//  numberFormat(10, 2)      == "10.00"
//  numberFormat(10.25, 2)   == "10.25"
//  numberFormat(12.3456, 2) == "12.3456"
//  numberFormat(10.90)      == "10.9"
//  numberFormat(10)         == "10"
//  numberFormat(10.25)      == "10.25"
//  numberFormat(12.3456)    == "12.3456"
C.numberFormat = function (n, decimalPlaces) {
	if (decimalPlaces === undefined) decimalPlaces = null;

	var parts = n.toString().split('.');
	if (parts.length === 1) {
		parts[1] = '';
	}

	// Commify
	parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

	// Trim 0's from the end
	var decimals = parts[1].replace(/[0]*$/, '');
	// Add 0's to the end
	while (decimals !== null && decimals.length < decimalPlaces) {
		decimals += '0';
	}
	var showDecimals = (decimalPlaces === null) ? decimals.length > 0 : decimalPlaces > 0;
	return parts[0] + (showDecimals ? "." + decimals : '');
}

C.renderMoney = function (val) {
	val = parseMoney(val);
	if (isNaN(val)) {
		return 'None';
	}
	return '$' + C.numberFormat(val, 2); // TODO: support precision based on the app setting
};